import React from "react";

const Footer = () => {
  return (
    <div class="container">
      <footer class="py-3 my-4 ">
        <ul class="nav justify-content-center border-bottom pb-3 mb-3">
          <li>Creado por Juan Ospina</li> 
        </ul>
        <p class="text-center text-body-secondary">© 2023 Company, Inc</p>
      </footer>
    </div>
    )
} 

export {
  Footer
}